import { render, staticRenderFns } from "./PaginationComp.vue?vue&type=template&id=0277d350"
import script from "./PaginationComp.vue?vue&type=script&lang=js"
export * from "./PaginationComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports